import CheckIcon from '@/components/Icons/CheckIcon';
import type { FC } from 'react';

interface Props {
  amenities: string[] | undefined;
}

const PropertyFeaturesCard: FC<Props> = ({ amenities }) => {
  if (!amenities || amenities.length === 0) {
    return null;
  }

  return (
    <div className="bg-white p-8 rounded-none border border-gray-200">
      <h2 className="text-2xl font-bold text-gray-900 mb-6">Floor Plan Features</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {amenities.map((feature) => (
          <div key={`property-feature-${feature}`} className="flex items-center">
            <CheckIcon className="w-5 h-5 mr-3 text-sage-600 flex-shrink-0" />
            <span className="text-gray-700">{feature}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PropertyFeaturesCard;
